export default __webpack_public_path__ + "static/media/nbyula_logo.ca7127f9.jpg";